module.exports = "<form [formGroup]=\"filterForm\">\n  <input\n    [placeholder]=\"placeholder\"\n    (keyup)=\"emitData()\"\n    class=\"search-icon\"\n    formControlName=\"filter\"\n    pInputText\n    type=\"text\"\n  >\n  <button\n    *ngIf=\"buttonVisibility()\"\n    (click)=\"clearInputField()\"\n    class=\"ui-button-danger\"\n    icon=\"fa fa-close\"\n    pButton\n    type=\"button\"\n  >\n  </button>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// /dist/src/app/shared/filter/filter.component.html
// module id = ../../../../../src/app/shared/filter/filter.component.html
// module chunks = main